export default __webpack_public_path__ + "static/media/SEC1670.34I-39905_-24349_0.8bfb54ec.jpg";